import { useContext } from 'react'

import type { UseEntitlementsReturn } from '@hapana/shared/web/hooks/entitlements.hooks'

import { EntitlementsContext } from '_contexts/entitlements.context'

/**
 * Read the current site's entitlements from the app-level `EntitlementsProvider`.
 *
 * Throws if used outside the provider — every gated route/component in Core sits under the
 * provider mounted in `AppLayout`, so a missing context means a wiring mistake, not a runtime state.
 */
export const useCoreEntitlements = (): UseEntitlementsReturn => {
  const context = useContext(EntitlementsContext)
  if (!context) {
    throw new Error('useCoreEntitlements must be used within EntitlementsProvider')
  }
  return context
}
